import {
  Box,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React, { useEffect, useState } from "react";
// import { DicomIcon } from "../../../common/components/assets/commonassets/CommonAssets";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
// import CommonDicomModal from "../../../common/components/Custom Hooks/CommonDicomModal";
import useGeneratePdf from "../../../common/components/printModal/GeneratePdfHook";
import {
  GetPathologyDocument,
  GetRadiologyDocument,
  getCasePaper,
  getDocumentPath,
  getPatientVisitLisit,
} from "../services/EMRServices/emrServices";
// import { getImage } from "../services/EMRServices/oncologyServices";
// import { getHistoryVisitData } from "../../services/oncologyEmr/OncologyEmrServices";
import Thumbnail from "../common/Thumbnail1.png";
// import DentistPatientHistory from "../dentistemr/DentistPatientHistory";
// import PastHistoryModal from "../emr/oncologyEMR/pasthistory/PatientHistoryView";
import { MLCIcon, PergentIcon } from "./EmrCommonAsset/Asset";
// import EntPatientHistoryView from "../entemr/EntPatientHistoryView";
// import GynacPatientHistoryView from "../gynacemr/GynacPatientHistoryView";
import PathologyReportModal from "./PathologyReportModal";
import "./StyleScroll.css";
const FilterChip = [
  {
    id: "All",
    label: "All",
    value: "All",
  },
  {
    id: "OPD",
    label: "OPD",
    value: "OPD",
  },
  {
    id: "IPD",
    label: "IPD",
    value: "IPD",
  },
  {
    id: "Surgical",
    label: "Surgical",
    value: "Surgical",
  },
  {
    id: "MLC",
    label: "MLC",
    value: "MLC",
  },
  {
    id: "ANC",
    label: "ANC",
    value: "ANC",
  },
];

function PatientHistoryModalNewAll(props) {
  const { patientDetails } = props;
  const [sliderReset, setSliderReset] = useState(0);
  const [patientVisitData, setPatientVisitData] = useState([]);
  const [data, setData] = useState();
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedRow, setSelectedRow] = useState(0);
  // const patientData = location.state;
  let userRole = JSON.parse(localStorage.getItem("loggedUser"));
  const [anc, setAnc] = useState(null);
  const [documentType, setDocumentType] = useState(null);
  const [Index, setIndex] = useState(0);
  const [filteredData, setFilteredData] = useState([]);
  const [AllDocument, setAllDocument] = useState([]);
  const [pdf, setpdf] = useState(null);
  const [documentView, setDocumentView] = useState(false);
  const [image, setImage] = useState(null);
  const [pathHistoryData, setPathHistoryData] = useState([]);
  const [radioHistoryData, setRadioHistoryData] = useState([]);
  const [LIMSType, setLIMSType] = useState("Pathology");
  const [openInvestigationModal, setOpenInvestigationModal] = useState(false);
  const [filterDocumentArr, setFilterDocumentArr] = useState(null);
  const [openDicomModal, setOpenDicomModal] = useState(false);

  useEffect(() => {
    if (selectedRow !== 0 && props.openPatientHistory === true) {
      let obj = {
        department: selectedRow?.department,
        patientInfoId:
          props.patientDetails?.patientId || props.patientDetails?.PatientId,
        visitIdList: [selectedRow?.visitId],
        visitNumber: [selectedRow?.visitNumber],
        doctorId: selectedRow?.doctorId,
      };
      // getHistoryVisitData(obj).then((response) => {
      //   if (response.data?.statusCode === 200) {
      //     setData(response.data.result);
      //     setAnc(response.data.map);
      //   } else {
      //   }
      // });
    }
  }, [selectedRow, props.openPatientHistory]);

  const [documentArray, setDocumentArray] = useState([]);

  useEffect(() => {
    if (documentArray?.length > 0) {
      let tempDocuments = [...documentArray];
      if (data !== null) {
        if (data?.documents !== null && data?.documents !== undefined) {
          for (let obj of data?.documents)
            for (let val of JSON.parse(obj?.docpath)) {
              tempDocuments.push(val);
              setDocumentArray(tempDocuments);
            }
        }
      }
    }
  }, [data]);

  useEffect(() => {
    if (
      (props.patientDetails?.patientId !== undefined ||
        props.patientDetails?.PatientId) &&
      userRole?.loginUnitId !== undefined &&
      props.openPatientHistory === true
    ) {
      getPatientVisitLisit(
        props.patientDetails?.patientId ||
          props.patientDetails?.PatientId ||
          patientDetails ||
          patientDetails?.patientId,
        userRole?.loginUnitId,
      ).then((response) => {
        setPatientVisitData(response.data.result);
      });
    }
  }, [props.patientDetails, userRole?.loginUnitId, props.openPatientHistory]);

  useEffect(() => {
    if (selectedRow !== undefined && props.openPatientHistory === true) {
      let DocumentObj = {
        visitId: selectedRow?.visitId,
        unitId: userRole?.loginUnitId,
        department: selectedRow?.department,
        patientId:
          props.patientDetails?.patientId || props.patientDetails?.PatientId,
      };
      getDocumentPath(DocumentObj).then((response) => {
        setDocumentType(response.data.result);
      });
    }
  }, [selectedRow, props.openPatientHistory]);

  useEffect(() => {
    if (documentType && documentType?.length > 0) {
      const pathologyDocuments = documentType
        .filter((doc) => doc.testType === "Pathology")
        .map((doc) => ({
          patientVisitId: selectedRow?.visitId,
          orderId: doc?.orderId,
          investigationId: [doc?.investigationId],
          unitId: userRole?.loginUnitId,
        }));
      const fetchDocuments = async () => {
        try {
          const responses = await Promise.all(
            pathologyDocuments.map((obj) => GetPathologyDocument(obj)),
          );
          let documentTypeFilterd = documentType.filter(
            (list) => list.testType === "Pathology",
          );
          const updatedDocumentArray = responses.map((response, index) => ({
            ...response,
            name: documentTypeFilterd[index]?.name,
          }));
          if (updatedDocumentArray?.length > 0) {
            setAllDocument((prev) => [
              ...prev,
              { Pathology: updatedDocumentArray },
            ]);
          }
        } catch (error) {}
      };
      fetchDocuments();
    }
  }, [documentType, selectedRow]);

  useEffect(() => {
    if (documentType && documentType?.length > 0) {
      const pathologyDocuments = documentType
        .filter((doc) => doc.testType === "Radiology")
        .map((doc) => ({
          patientVisitId: selectedRow?.visitId,
          orderId: doc?.orderId,
          investigationId: [doc?.investigationId],
          unitId: userRole?.loginUnitId,
        }));
      const fetchDocuments = async () => {
        try {
          const responses = await Promise.all(
            pathologyDocuments.map((obj) => GetRadiologyDocument(obj)),
          );
          let documentTypeFilterd = documentType.filter(
            (list) => list.testType === "Radiology",
          );
          const updatedDocumentArray = responses.map((response, index) => ({
            ...response,
            name: documentTypeFilterd[index]?.name,
          }));
          if (updatedDocumentArray?.length > 0) {
            setAllDocument((prev) => [
              ...prev,
              { Radiology: updatedDocumentArray },
            ]);
          }
        } catch (error) {}
      };
      fetchDocuments();
    }
  }, [documentType, selectedRow]);

  useEffect(() => {
    if (documentType && documentType?.length > 0) {
      const pathologyDocuments = documentType
        .filter((doc) => doc.testType === "Cardiology")
        .map((doc) => ({
          patientVisitId: selectedRow?.visitId,
          orderId: doc?.orderId,
          investigationId: [doc?.investigationId],
          unitId: userRole?.loginUnitId,
        }));
      const fetchDocuments = async () => {
        try {
          const responses = await Promise.all(
            pathologyDocuments.map((obj) => GetRadiologyDocument(obj)),
          );
          let documentTypeFilterd = documentType.filter(
            (list) => list.testType === "Cardiology",
          );
          const updatedDocumentArray = responses.map((response, index) => ({
            ...response,
            name: documentTypeFilterd[index]?.name,
          }));
          if (updatedDocumentArray?.length > 0) {
            setAllDocument((prev) => [
              ...prev,
              { Cardiology: updatedDocumentArray },
            ]);
          }
        } catch (error) {}
      };
      fetchDocuments();
    }
  }, [documentType, selectedRow]);

  useEffect(() => {
    if (selectedRow?.visitId > 0) {
      getCasePaper(selectedRow?.visitId, selectedRow.doctorId).then(
        (response) => {
          setAllDocument((prev) => [...prev, { CasePaper: response }]);
        },
      );
    }
  }, [selectedRow?.visitId]);

  const [casePaper, setCasePaper] = useState(null);

  useEffect(() => {
    let tempArr = [];
    if (AllDocument?.length > 0 && props.openPatientHistory === true) {
      let radiology = AllDocument.filter(function (e) {
        return e.Radiology;
      });
      let pathology = AllDocument.filter(function (e) {
        return e.Pathology;
      });
      let casePaper = AllDocument.filter(function (e) {
        return e.CasePaper;
      });
      let mrd = AllDocument.filter(function (e) {
        return e.mrd;
      });
      let cardiology = AllDocument.filter(function (e) {
        return e.Cardiology;
      });
      setCasePaper(casePaper[0]?.CasePaper);

      let newMrd = mrd[0]?.mrd?.map((val) => ({
        ...val,
        docpath: JSON.parse(val.docpath),
      }));

      tempArr.push(
        pathology[0],
        radiology[0],
        casePaper[0],
        { mrd: newMrd },
        cardiology[0],
      );
      setFilterDocumentArr(tempArr);
    }
  }, [AllDocument]);

  const fileURL = useGeneratePdf(pdf);
  // if (!AllDocument) {
  //   return <div>No documents available</div>;
  // }
  useEffect(() => {
    if (documentType && documentType?.length > 0) {
      let tempDocumentArray = [];
      for (let i = 0; i < documentType?.length; i++) {
        if (documentType[i]?.isMrd === true) {
          let mrdImage = documentType[i]?.mrdImages;
          if (mrdImage && mrdImage?.length > 0) {
            setAllDocument((prev) => [...prev, { mrd: mrdImage }]);
          }
        }
      }
    }
  }, [documentType]);

  function arrayBufferToBase64(buffer) {
    let binary = "";
    let bytes = new Uint8Array(buffer);
    let len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return window.btoa(binary);
  }

  useEffect(() => {
    if (image && image?.length > 0) {
      const currentImage = image[0];
      if (currentImage.filePath && currentImage.fileName) {
        const documentType = currentImage.fileName.split(".")[1]?.toLowerCase();

        // getImage(currentImage.filePath, currentImage.fileName)
        //   .then((response) => {
        //     if (documentType !== "pdf") {
        //       let newImage =
        //         "data:image/jpeg;base64," + arrayBufferToBase64(response?.data);
        //       setImage(newImage); 
        //     } else if (documentType === "pdf") {
        //       setpdf(response); 
        //     }
        //   })
          // .catch((error) => {});
      }
    }
  }, [image]);

  useEffect(() => {

    if (filterDocumentArr?.length > 0) {
      let mrdArr = [...filterDocumentArr];
      console.log("mrdArrarr", mrdArr);
      let mrdData = mrdArr[3]?.mrd;
      if (mrdData?.length > 0) {
        for (let m = 0; m < mrdData?.length; m++) {
          let getDocPath = mrdData[m].docpath;
          console.log("getDocPath123", getDocPath);
          getDocPath?.forEach((docVal, docIndex) => {
            const documentType = docVal?.fileName
              ?.split(".")?.[1]
              ?.toLowerCase();
            // getImage(docVal?.filePath, docVal?.fileName)
            //   .then((response) => {
            //     if (documentType !== "pdf") {
            //       docVal.fileSrc =
            //         "data:image/jpeg;base64," +
            //         arrayBufferToBase64(response?.data);
            //       docVal.isImage = true;
            //       // }
            //     } else {
            //       docVal.filePdf = response?.data;
            //       docVal.isPdf = true;
            //     }
            //   })
            //   .catch((error) => {});
          });
        }
      }
    }
  }, [filterDocumentArr]);

  useEffect(() => {
    const initialData = patientVisitData.filter((item) => item);
    setFilteredData(initialData);
  }, [patientVisitData]);

  useEffect(() => {
    if (filteredData?.length > 0) {
      setSelectedIndex(0);
      setSelectedRow(filteredData[0]);
    }
  }, [filteredData]);

  let vitalsFill;
  let pastHistoryFill;
  let examinations;
  let obstetricHistory;
  useEffect(() => {
    if (data?.length > 0) {
      examinations = Object.values(props.data?.examinations);
      obstetricHistory = Object.values(props.data?.obstetricHistory);
      vitalsFill = Object.values(data?.vitals);
      pastHistoryFill = Object.values(data.pastHistory);
    }
  }, [data]);

  useEffect(() => {
    const iframe = document.querySelector(".pdf-preview");
    if (iframe) {
      iframe.onload = () => {
        const iframeDoc =
          iframe.contentDocument || iframe.contentWindow.document;
        iframeDoc.body.style.overflow = "hidden";
      };
    }
  }, []);
  const [isOpenFilter, setIsOpenFilter] = useState(false);
  const toggleDrawerOpen = () => {
    setIsOpenFilter((prevIsOpen) => !prevIsOpen);
  };
  const areAllVitalsNull =
    data?.vitals &&
    typeof data?.vitals === "object" &&
    Object.values(data?.vitals).every((value) => value === null);

  const isAnyPastHistoryPresent =
    data?.pastHistory &&
    typeof data?.pastHistory === "object" &&
    Object.values(data?.pastHistory).some(
      (value) => value !== null && value !== true,
    );
  
  return (
    <div>
      <Modal
        open={props.openPatientHistory}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            border: "2px solid #848211",

            boxShadow: 24,
            px: 2,
            width: "95%",
            height: "95%",
            overflowY: "auto",

            "&::-webkit-scrollbar": {
              width: "5px",
            },
            "&::-webkit-scrollbar-track": {
              background: "#C8DDFD",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#0B83A5",
              borderRadius: "6px",
            },
          }}
          className="w-[95%] lg:w-[99%]"
        >
          <div className="flex py-2 gap-2">
            <label className="  font-bold  text-center">
              Patient History Sheet
            </label>
            <div className="justify-end">
              <CancelPresentationIconButton
                onClick={() => {
                  props.setPatientHistory(false);
                  setDocumentView(false);
                  setpdf(null);
                  setAllDocument([]);
                  setFilterDocumentArr([]);
                  setDocumentType([]);
                  setDocumentArray([]);
                  setImage(null);
                  setSelectedRow(0);
                }}
              />
            </div>
          </div>
          <div className="w-full flex gap-2">
            {isOpenFilter === false ? (
              <div className="w-[20%] border border-gray-300 p-2 bg-white shadow-md rounded-md ">
                <div className="flex justify-between ">
                  <h1 className="text-[#1E3A8A] font-semibold 2xl:text-[14px] lg:text-[13px]">
                    Visit
                  </h1>
                  <button
                    type="button"
                    onClick={() => {
                      toggleDrawerOpen();
                    }}
                  >
                    <svg
                      width="22"
                      height="22"
                      viewBox="0 0 22 22"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <circle cx="11" cy="11" r="10" fill="#1E3A8A" />
                      <path
                        d="M12.8179 6.45459L8.93428 10.9514C8.57011 11.3731 8.62079 12.0111 9.04697 12.37L12.8179 15.5455"
                        stroke="white"
                        stroke-width="1.5"
                        stroke-linecap="round"
                      />
                    </svg>
                  </button>
                </div>
                <hr className="p-[4px] text-slate-900" />
                <div className=" flex flex-wrap gap-1 sticky">
                  {FilterChip.map((row, idx) => {
                    return (
                      <button
                        key={idx}
                        onClick={(e) => {
                          setIndex(idx);

                          let newData;
                          if (row.label === "ANC") {
                            newData = patientVisitData.filter(
                              (item) => item.isAnc,
                            );
                          } else if (row.label === "OPD") {
                            newData = patientVisitData.filter(
                              (item) => item.isOpd,
                            );
                          } else if (row.label === "IPD") {
                            newData = patientVisitData.filter(
                              (item) => item.isIpd,
                            );
                          } else if (row.label === "MLC") {
                            newData = patientVisitData.filter(
                              (item) => item.isMlc,
                            );
                          } else if (row.label === "Surgical") {
                            newData = patientVisitData.filter(
                              (item) => item.isSurgical,
                            );
                          } else if (row.label === "All") {
                            newData = patientVisitData.filter((item) => item);
                          }

                          setFilteredData(newData);
                        }}
                      >
                        <div
                          className={`border  border-[#1E3A8A] flex-wrap text-[12px] rounded-full text-[#1E3A8A] p-[2px] ${
                            Index === idx
                              ? "bg-blue-800 text-white"
                              : "bg-white text-[#1E3A8A]"
                          }`}
                        >
                          <div className="px-3">{row.label}</div>
                        </div>
                      </button>
                    );
                  })}
                </div>
                <div className="2xl:h-[720px] xl:h-[420px] h-[250px] block   overflow-auto">
                  <div>
                    {filteredData.map((row, index) => {
                      console.log("selectedIndex", selectedIndex, index);
                      return (
                        <fieldset
                          key={index}
                          onClick={() => {
                            setDocumentView(false);
                            if (selectedIndex !== index) {
                              setSelectedIndex(index);
                              setpdf(null);
                              setAllDocument([]);
                              setFilterDocumentArr([]);
                              setDocumentType([]);
                              setDocumentArray([]);
                              setImage(null);
                              setSelectedRow(row);
                            }
                          }}
                          className={`w-full`}
                        >
                          <div
                            className={`flex justify-between p-1    my-2 rounded-md border ${
                              selectedIndex === index
                                ? "bg-blue-800 text-white"
                                : "bg-white text-black"
                            }border-gray-300  shadow-sm`}
                          >
                            <div className="w-[75%] ">
                              <div
                                className={` ${
                                  selectedIndex === index
                                    ? "text-white  "
                                    : "text-blue-800 "
                                } font-semibold text-start 2xl:text-[16px] xl:text-[14px] lg:text-[12px] text-[13px]`}
                              >
                                {row?.doctor}
                              </div>
                              <div
                                className={` ${
                                  selectedIndex === index
                                    ? "text-white  "
                                    : "text-gray-500"
                                } 2xl:text-[14px] xl:text-[12px] text-start lg:text-[10px] text-[10px] `}
                              >
                                {row?.department}
                              </div>
                              <div
                                className={` ${
                                  selectedIndex === index
                                    ? "text-white  "
                                    : "text-gray-500"
                                } 2xl:text-[14px] xl:text-[12px] text-start lg:text-[12px] text-[10px]`}
                              >
                                {row?.visitDate}
                              </div>
                            </div>
                            <div className="w-[25%] mt-1   ">
                              <div className="flex justify-start">
                                <>
                                  {row?.isMlc === true ? (
                                    <>
                                      <MLCIcon />
                                    </>
                                  ) : (
                                    ""
                                  )}
                                </>
                                <>
                                  {row?.isAnc === true ? <PergentIcon /> : ""}
                                </>
                              </div>
                              <div
                                className={` ${
                                  selectedIndex === index
                                    ? "text-white  "
                                    : "text-blue-800"
                                }  font-bold 2xl:text-[14px] xl:text-[12px] lg:text-[12px] justify-start flex whitespace-nowrap text-[10px]`}
                              >
                                {row?.duration} min
                              </div>
                            </div>
                          </div>
                        </fieldset>
                      );
                    })}
                  </div>
                </div>
              </div>
            ) : (
              <div className="w-[2%]">
                <button
                  type="button"
                  onClick={() => {
                    toggleDrawerOpen();
                  }}
                >
                  <svg
                    width="22"
                    height="22"
                    viewBox="0 0 22 22"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <circle cx="11" cy="11" r="10" fill="#1E3A8A" />
                    <path
                      d="M12.8179 6.45459L8.93428 10.9514C8.57011 11.3731 8.62079 12.0111 9.04697 12.37L12.8179 15.5455"
                      stroke="white"
                      stroke-width="1.5"
                      stroke-linecap="round"
                    />
                  </svg>
                </button>
              </div>
            )}
            <div className={`${isOpenFilter === true ? "w-[78%]" : "w-[60%]"}`}>
              <div className="grid xl:grid-cols-3 lg:grid-cols-3 py-1 px-1 bg-[#F0FFEE] border border-gray-200 shadow-md rounded-md">
                <div className="xl:text-sm lg:text-[12px] text-slate-600  flex items-center space-x-2 overflow-x-clip">
                  <div className=" font-semibold whitespace-nowrap w-[100px]">
                    Patient Name
                  </div>
                  <div>:</div>
                  <p className="xl:text-sm lg:text-[12px] text-slate-600 overflow-hidden text-ellipsis">
                    <p className="capitalize  truncate w-[4rem] xl:w-[8rem] min-[1440px]:w-full 2xl:w-full ">
                      {props?.patientDetails?.patientName ||
                        props?.patientDetails?.["Patient Name"]}
                    </p>
                  </p>
                </div>

                <div className="xl:text-sm lg:text-[12px] text-slate-600 space-x-2  flex items-center overflow-x-clip">
                  <div className=" font-semibold  w-[70px]">UHID </div>
                  <div>:</div>
                  <p className="xl:text-sm lg:text-[12px] text-slate-600 overflow-hidden text-ellipsis">
                    <p className="capitalize  truncate w-[4rem] xl:w-[8rem] min-[1440px]:w-full 2xl:w-full ">
                      {props?.patientDetails?.uhid ||
                        props?.patientDetails?.UHID}
                    </p>
                  </p>
                </div>

                <div className="xl:text-sm lg:text-[12px] text-slate-600 space-x-2 flex items-center overflow-x-clip">
                  <div className=" font-semibold  w-[100px]">Age/Gender </div>
                  <div>:</div>
                  <p className="xl:text-sm lg:text-[12px] text-slate-600 overflow-hidden text-ellipsis">
                    <p className="capitalize  truncate w-[4rem] xl:w-[8rem] min-[1440px]:w-full 2xl:w-full ">
                      {props?.patientDetails?.age} /{" "}
                      {props?.patientDetails?.gender?.charAt(0)}
                    </p>
                  </p>
                </div>

                <div className="xl:text-sm lg:text-[12px] text-slate-600 space-x-2 flex items-center overflow-x-clip">
                  <div className=" font-semibold  w-[100px]">Dept. </div>
                  <div>:</div>

                  <p className="xl:text-sm lg:text-[12px] text-slate-600 overflow-hidden text-ellipsis">
                    <p className="capitalize truncate w-[4rem] xl:w-[8rem] min-[1440px]:w-full 2xl:w-full ">
                      {selectedRow?.department
                        ? selectedRow?.department
                        : props?.patientDetails?.department}
                    </p>
                  </p>
                </div>

                <div className="xl:text-sm lg:text-[12px] text-slate-600  space-x-2 flex items-center overflow-x-clip">
                  <div className=" font-semibold  w-[70px]">Doctor </div>
                  <div>:</div>

                  <p className="xl:text-sm lg:text-[12px] text-slate-600 overflow-hidden text-ellipsis">
                    <p className="capitalize truncate w-[4rem] xl:w-[8rem] min-[1440px]:w-full 2xl:w-full ">
                      {selectedRow?.doctor
                        ? selectedRow?.doctor
                        : props?.patientDetails?.doctor}
                    </p>
                  </p>
                </div>
              </div>
              <div className="flex justify-end">
                <Tooltip title="Dicom">
                  <button type="button" onClick={() => setOpenDicomModal(true)}>
                    {/* <DicomIcon /> */}
                  </button>
                </Tooltip>
              </div>
              {documentView === false ? (
                <div className="px-2 mt-1">
                  {selectedRow?.department !== "oncology" &&
                  selectedRow?.department !== "Obst. & Gynaecology" &&
                  selectedRow?.department !== "E N T" &&
                  selectedRow?.department !== "Dental" ? (
                    <div className="2xl:h-[720px] xl:h-[400px] h-[250px] overflow-auto">
                      {patientVisitData?.length > 0 && (
                        <>
                          <div className="border border-pink-900 bg-gray-100 rounded-md p-2">
                            <div className="text-sm font-semibold w-full  xl:text-[20px]  lg:text-[14px] my-2 ">
                              History
                            </div>

                            {pastHistoryFill?.some(
                              (val) => val !== null && val !== false,
                            ) || data?.pastHistory !== null ? (
                              <div className="lg:my-2 xl:my-2">
                                {isAnyPastHistoryPresent && (
                                  <div className="text-sm font-semibold w-full xl:text-[16px] lg:text-[12px] my-2  pl-2">
                                    Past History
                                  </div>
                                )}

                                <div className="grid grid-cols-1 mb-1 pl-4">
                                  {data?.pastHistory?.dmDescription !==
                                    null && (
                                    <div className="flex space-x-2">
                                      <div className="font-semibold xl:text-sm lg:text-[12px] w-[20%]">
                                        DM
                                      </div>
                                      <div className="w-[2%]">:</div>
                                      <div className="w-[78%]">
                                        {data?.pastHistory?.dmDescription}
                                      </div>
                                    </div>
                                  )}
                                  {data?.pastHistory?.htnDescription !==
                                    null && (
                                    <div className="flex space-x-2">
                                      <div className="font-semibold xl:text-sm lg:text-[12px] w-[20%]">
                                        HTN
                                      </div>
                                      <div className="w-[2%]">:</div>
                                      <div className="w-[78%]">
                                        {data?.pastHistory?.htnDescription}
                                      </div>
                                    </div>
                                  )}
                                  {data?.pastHistory
                                    ?.heartDiseaseDescription !== null && (
                                    <div className="flex space-x-2">
                                      <div className="font-semibold xl:text-sm lg:text-[12px] w-[20%]">
                                        Heart
                                      </div>
                                      <div className="w-[2%]">:</div>
                                      <div className="w-[78%]">
                                        {
                                          data?.pastHistory
                                            ?.heartDiseaseDescription
                                        }
                                      </div>
                                    </div>
                                  )}
                                  {data?.pastHistory?.surgicalHistory !==
                                    null && (
                                    <div className="flex space-x-2">
                                      <div className="font-semibold xl:text-sm lg:text-[12px] w-[20%]">
                                        Surgical History
                                      </div>
                                      <div className="w-[2%]">:</div>
                                      <div className="w-[78%]">
                                        {data?.pastHistory?.surgicalHistory}
                                      </div>
                                    </div>
                                  )}
                                  {data?.pastHistory?.familyHistory !==
                                    null && (
                                    <div className="flex space-x-2">
                                      <div className="font-semibold xl:text-sm lg:text-[12px] w-[20%]">
                                        Family History
                                      </div>
                                      <div className="w-[2%]">:</div>
                                      <div className="w-[78%]">
                                        {data?.pastHistory?.familyHistory}
                                      </div>
                                    </div>
                                  )}
                                  {data?.pastHistory?.otherDescription !==
                                    null && (
                                    <div className="flex space-x-2">
                                      <div className="font-semibold xl:text-sm lg:text-[12px] w-[20%]">
                                        Other History
                                      </div>
                                      <div className="w-[2%]">:</div>
                                      <div className="w-[78%]">
                                        {data?.pastHistory?.otherDescription}
                                      </div>
                                    </div>
                                  )}
                                </div>
                              </div>
                            ) : null}

                            {data?.surgicalHistoryDetails !== null && (
                              <div className="lg:my-2 xl:my-2 ">
                                <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2 pl-2">
                                  Surgery History
                                </div>

                                <div className="xl:text-sm lg:text-[12px] mb-1 pl-4">
                                  {data?.surgicalHistoryDetails}
                                </div>
                              </div>
                            )}
                            {data?.medicalHistory !== null && (
                              <div className="lg:my-2 xl:my-2">
                                <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2 pl-2">
                                  Medical History
                                </div>
                                <div className="xl:text-sm lg:text-[12px] mb-1 pl-4">
                                  {data?.medicalHistory}
                                </div>
                              </div>
                            )}
                            {data?.allergies !== null &&
                            data?.allergies?.length > 0 ? (
                              <div className="lg:my-2 xl:my-2">
                                <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2 pl-2">
                                  Allergies
                                </div>
                                <div className="mb-1">
                                  {data?.allergies.map((row) => {
                                    return (
                                      <ul className="pl-4">
                                        <li className="flex">
                                          <div className=" w-[300px] text-sm ">
                                            {" "}
                                            • &nbsp;&nbsp;{row.allergyType}
                                          </div>{" "}
                                          {row.allergyDescription !== null && (
                                            <>
                                              <div className="text-sm">
                                                {row.allergyDescription}
                                              </div>{" "}
                                            </>
                                          )}
                                        </li>
                                      </ul>
                                    );
                                  })}
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                          {data?.complaints !== null &&
                            data?.complaints?.length > 0 && (
                              <div className="lg:my-2 xl:my-2">
                                <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                                  Complaints
                                </div>
                                <div className="mb-1">
                                  {data?.complaints.map((row) => {
                                    return (
                                      <ul className="list-disc">
                                        <li className="flex items-center">
                                          <div className=" text-gray-700  list-disc w-[300px] text-sm">
                                            {" "}
                                            • &nbsp;&nbsp;{row.complaint}
                                          </div>{" "}
                                          {row.since && (
                                            <div>Since &nbsp;&nbsp;</div>
                                          )}
                                          <div className="text-sm">
                                            {row.since}
                                          </div>
                                          &nbsp;&nbsp;<div>{row?.duration}</div>
                                        </li>
                                      </ul>
                                    );
                                  })}
                                </div>
                              </div>
                            )}
                          {vitalsFill?.some((val) => val !== null) ||
                          data?.vitals !== null ? (
                            <div>
                              {!areAllVitalsNull && (
                                <div className="text-sm font-semibold w-full xl:text-[16px] lg:text-[12px] my-2">
                                  Vitals
                                </div>
                              )}
                              <div className="grid lg:grid-cols-4 grid-cols-2 md:grid-cols-3 gap-y-1 mx-4 mb-1">
                                {data?.vitals?.temperature !== null &&
                                  data?.vitals?.temperature !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]   lg:text-[12px]">
                                        Temp
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.temperature}
                                        °F
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.pulseRate !== null &&
                                  data?.vitals?.pulseRate !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]   lg:text-[12px]">
                                        PR
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.pulseRate}{" "}
                                        bpm
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.spO2 !== null &&
                                  data?.vitals?.spO2 !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]  lg:text-[12px]">
                                        spO2
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.spO2} %
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.weight !== null &&
                                  data?.vitals?.weight !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px]  lg:text-[12px]">
                                        W
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.weight} kg
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.height !== null &&
                                  data?.vitals?.height !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                                        H
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.height} cm
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.bmi !== null &&
                                  data?.vitals?.bmi !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                                        BMI
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.bmi} kg/m2
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.respiration !== null &&
                                  data?.vitals?.respiration !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                                        Resp
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.respiration}{" "}
                                        bpm
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.bloodSugar !== null &&
                                  data?.vitals?.bloodSugar !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                                        BSL
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.bloodSugar}{" "}
                                        mg/di
                                      </div>
                                    </div>
                                  )}
                                {data?.vitals?.bsa !== null &&
                                  data?.vitals?.bsa !== 0 && (
                                    <div className="flex space-x-1">
                                      <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                                        BSA
                                      </div>

                                      <div className=" xl:text-sm lg:text-[12px]">
                                        :&nbsp;&nbsp;{data?.vitals?.bsa} mg/di
                                      </div>
                                    </div>
                                  )}
                                {(data?.vitals?.bloodPressureSystolic !==
                                  null &&
                                  data?.vitals?.bloodPressureSystolic !== 0) ||
                                  (data?.vitals?.bloodPressureDiastolic !==
                                    null &&
                                    data?.vitals?.bloodPressureDiastolic !==
                                      0 && (
                                      <div className="flex space-x-1">
                                        <div className="font-semibold xl:text-sm xl:w-[40px] lg:w-[30px] lg:text-[12px]">
                                          BP
                                        </div>

                                        <div className=" xl:text-sm lg:text-[12px]">
                                          :&nbsp;&nbsp;
                                          {data?.vitals?.bloodPressureSystolic}/
                                          {data?.vitals?.bloodPressureDiastolic}{" "}
                                          mmHg
                                        </div>
                                      </div>
                                    ))}
                              </div>
                            </div>
                          ) : null}

                          {data?.localExamination !== null && (
                            <div className="lg:my-2 xl:my-2">
                              <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                                Local Examination
                              </div>
                              <div className="xl:text-sm lg:text-[12px] mb-1">
                                {data?.localExamination}
                              </div>
                            </div>
                          )}

                          {data?.diagnosis?.length > 0 &&
                          data?.diagnosis !== null ? (
                            <div className="lg:my-2 xl:my-2">
                              <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                                Diagnosis
                              </div>
                              <div className="mb-1">
                                {data?.diagnosis.map((row) => {
                                  return (
                                    <div className="list-disc">
                                      <div className="flex items-center">
                                        <div className=" list-disc w-[400px] text-sm">
                                          {" "}
                                          • &nbsp;&nbsp;{row.icd}
                                        </div>{" "}
                                        {row.since && (
                                          <div>Since &nbsp;&nbsp; </div>
                                        )}
                                        <div className="text-sm">
                                          {row.since}
                                        </div>
                                        &nbsp;&nbsp;<div>{row?.duration}</div>
                                      </div>
                                    </div>
                                  );
                                })}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}

                          <div className="lg:my-2 xl:my-2">
                            <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                              Investigations
                            </div>
                            <div className="mb-1">
                              {data?.pathology?.length > 0 &&
                                data?.pathology.map((row) => {
                                  return (
                                    <ul className="list-disc">
                                      <li className="flex items-center text-sm ">
                                        {" "}
                                        • &nbsp;&nbsp;{row.investigation}{" "}
                                      </li>
                                    </ul>
                                  );
                                })}
                              {data?.radiology?.length > 0 &&
                                data?.radiology.map((row) => {
                                  return (
                                    <ul className="list-disc">
                                      <li className="flex items-center text-sm ">
                                        {" "}
                                        • &nbsp;&nbsp; {row.investigation}{" "}
                                      </li>
                                    </ul>
                                  );
                                })}
                              {data?.investigations?.length > 0 &&
                                data?.investigations.map((row) => {
                                  return (
                                    <ul className="list-disc">
                                      <li className="flex items-center text-sm ">
                                        {" "}
                                        • &nbsp;&nbsp; {row.investigation}{" "}
                                      </li>
                                    </ul>
                                  );
                                })}
                            </div>
                          </div>

                          {data?.services?.length > 0 ? (
                            <div className="lg:my-2 xl:my-2">
                              <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                                Services
                              </div>
                              <div className="mb-1">
                                {data?.services.map((row, index) => {
                                  return (
                                    <ul key={index} className="">
                                      <li className=" text-sm ">
                                        • &nbsp;&nbsp;{row.serviceName}{" "}
                                      </li>
                                    </ul>
                                  );
                                })}
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          {data?.treatmentAdvices !== null &&
                            data?.treatmentAdvices?.length > 0 && (
                              <div className="lg:my-2 xl:my-2">
                                <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                                  Advice
                                </div>
                                <div className="text-sm  flex mb-1 space-x-2 font-semibold p-2 ">
                                  {data?.treatmentAdvices !== null &&
                                    data?.treatmentAdvices.map((row) => {
                                      return (
                                        <div className="flex space-x-2  bg-blue-300 p-2 rounded-md">
                                          {row}
                                        </div>
                                      );
                                    })}
                                </div>
                              </div>
                            )}
                          {data?.prescriptions?.length > 0 ? (
                            <div className="lg:my-2 xl:my-2">
                              <div className="text-sm font-semibold w-full  xl:text-[16px]  lg:text-[12px] my-2">
                                Medication
                              </div>

                              <TableContainer
                                sx={{
                                  "&::-webkit-scrollbar": {
                                    width: 7,
                                    height: 10,
                                  },
                                  "&::-webkit-scrollbar-track": {
                                    backgroundColor: "#ebebeb",
                                  },
                                  "&::-webkit-scrollbar-thumb": {
                                    backgroundColor: "#7393b3",
                                    borderRadius: 4,
                                  },
                                  weight: "500px",
                                  height: "200px",
                                  overflow: "auto",
                                }}
                              >
                                <Table
                                  size="small"
                                  stickyHeader
                                  aria-label="sticky table"
                                  sx={{
                                    paddingY: "scroll",
                                  }}
                                >
                                  <TableHead>
                                    <TableRow
                                      sx={{
                                        "& th": {
                                          backgroundColor: "#F1F1F1",
                                        },
                                      }}
                                    >
                                      <TableCell
                                        className="whitespace-nowrap"
                                        sx={{ width: 100 }}
                                      >
                                        <span className="text-gray-600 text-xs font-semibold">
                                          Drug Name
                                        </span>
                                      </TableCell>

                                      <TableCell
                                        className="whitespace-nowrap"
                                        sx={{ width: 100 }}
                                      >
                                        <span className="text-gray-600 text-xs font-semibold">
                                          Frequency
                                        </span>
                                      </TableCell>
                                      <TableCell
                                        className="whitespace-nowrap"
                                        sx={{ width: 100 }}
                                      >
                                        <span className="text-gray-600 text-xs font-semibold">
                                          Instructions
                                        </span>
                                      </TableCell>
                                      <TableCell
                                        className="whitespace-nowrap"
                                        sx={{ width: 100 }}
                                      >
                                        <span className="text-gray-600 text-xs font-semibold">
                                          Dose
                                        </span>
                                      </TableCell>
                                      <TableCell
                                        className="whitespace-nowrap"
                                        sx={{ width: 100 }}
                                      >
                                        <span className="text-gray-600 text-xs font-semibold">
                                          Duration
                                        </span>
                                      </TableCell>
                                      <TableCell
                                        className="whitespace-nowrap"
                                        sx={{ width: 100 }}
                                      >
                                        <span className="text-gray-600 text-xs font-semibold">
                                          Quantity
                                        </span>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>
                                    {data?.prescriptions?.map((row) => {
                                      return (
                                        <TableRow key={row.id} hover={false}>
                                          <TableCell sx={{ width: 200 }}>
                                            {row.drugName}
                                          </TableCell>

                                          <TableCell sx={{ width: 200 }}>
                                            {row.frequency}
                                          </TableCell>
                                          <TableCell sx={{ width: 100 }}>
                                            {row.instruction}
                                          </TableCell>
                                          <TableCell sx={{ width: 50 }}>
                                            {row.dosage}
                                          </TableCell>

                                          <TableCell sx={{ width: 150 }}>
                                            {row.duration} &nbsp;{" "}
                                            {row.durationIn}
                                          </TableCell>
                                          <TableCell sx={{ width: 50 }}>
                                            {row.quantity}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    })}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          ) : (
                            ""
                          )}
                        </>
                      )}
                    </div>
                  ) : selectedRow?.department === "oncology" ? (
                    <div className="2xl:h-[720px] xl:h-[420px] h-[250px] overflow-auto">
                      {/* <PastHistoryModal
                        sliderReset={sliderReset}
                        data={data}
                        setData={setData}
                      /> */}
                    </div>
                  ) : selectedRow?.department === "Obst. & Gynaecology" ? (
                    <div className="2xl:h-[720px] xl:h-[400px] h-[250px] overflow-auto">
                      {/* <GynacPatientHistoryView
                        data={data}
                        setData={setData}
                        vitalsFill={vitalsFill}
                        pastHistoryFill={pastHistoryFill}
                        examinations={examinations}
                        obstetricHistory={obstetricHistory}
                      /> */}
                    </div>
                  ) : selectedRow?.department === "E N T" ? (
                    <div className="2xl:h-[720px] xl:h-[400px] h-[250px] overflow-auto">
                      {/* <EntPatientHistoryView
                        data={data}
                        setData={setData}
                        vitalsFill={vitalsFill}
                        pastHistoryFill={pastHistoryFill}
                      /> */} 
                    </div>
                  ) : selectedRow.department === "Dental" ? (
                    <div className="2xl:h-[720px] xl:h-[400px] h-[250px] overflow-auto">
                      {/* <DentistPatientHistory data={data} setData={setData} /> */}
                    </div>
                  ) : (
                    "No History Preview"
                  )}
                </div>
              ) : (
                <div className="max-h-screen">
                  {pdf !== null ? (
                    <div className="2xl:h-[600px] xl:h-[400px] h-[250px] ">
                      <iframe
                        width="100%"
                        height="600"
                        src={`${fileURL}#toolbar=0&navpanes=0&scrollbar=0`}
                        target="_blank"
                      />
                    </div>
                  ) : (
                    <img src={image} name="img" alt="Image" />
                  )}
                </div>
              )}
            </div>
            <div className="w-[20%]">
              <div className="2xl:h-[750px] xl:h-[520px] h-[180px] overflow-auto ">
                <div className="border border-gray-300 rounded-md mb-2">
                  <div
                    className="bg-[#FFF1DB] rounded-t-md font-semibold text-[#1E3A8A] p-2
"
                  >
                    Investigations
                  </div>
                  <div>
                    {filterDocumentArr?.length > 0 ? (
                      filterDocumentArr.every(
                        (row) =>
                          !row?.Pathology || row?.Pathology?.length === 0,
                      ) &&
                      filterDocumentArr.every(
                        (row) =>
                          !row?.Radiology || row?.Radiology?.length === 0,
                      ) &&
                      filterDocumentArr.every(
                        (row) =>
                          !row?.Cardiology || row?.Cardiology?.length === 0,
                      ) ? (
                        <div className="text-center text-gray-500 my-4">
                          No document uploaded
                        </div>
                      ) : (
                        filterDocumentArr.map((row, index) => {
                          console.log("row7878", row);

                          const pathologyEmpty =
                            !row?.Pathology || row?.Pathology?.length === 0;
                          const radiologyEmpty =
                            !row?.Radiology || row?.Radiology?.length === 0;
                          const cardiologyEmpty =
                            !row?.Cardiology || row?.Cardiology?.length === 0;
                          return (
                            <div key={index}>
                              {!pathologyEmpty && (
                                <div>
                                  {row?.Pathology.map((item, itemIndex) => {
                                    const blob = new Blob([item.data], {
                                      type: "application/pdf",
                                    });
                                    const url = URL.createObjectURL(blob);
                                    console.log(
                                      "The item in the iframe tag :",
                                      item,
                                    );
                                    return (
                                      <div
                                        className="bg-white shadow-md rounded-md border border-gray-300 m-5 p-1"
                                        key={itemIndex}
                                      >
                                        <div
                                          className="flex items-center justify-center"
                                          onClick={(e) => {
                                            setDocumentView(true);
                                            setpdf(item);
                                          }}
                                        >
                                          <div className="cursor-pointer overflow-hidden relative w-[100px] h-[141px]">
                                            <fieldset disabled>
                                              {item?.name !== pdf?.name ? (
                                                <iframe
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                  }}
                                                  title="PDF Preview"
                                                  className="absolute inset-0 w-full h-full"
                                                  src={`${url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                                                  style={{
                                                    pointerEvents: "none",
                                                    overflow: "hidden",
                                                    msOverflowStyle: "none",
                                                    scrollbarWidth: "none",
                                                  }}
                                                />
                                              ) : (
                                                ""
                                              )}
                                              <iframe
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                }}
                                                title="PDF Preview"
                                                className="absolute inset-0 w-full h-full"
                                                src={
                                                  item?.name === pdf?.name
                                                    ? `${url}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`
                                                    : ""
                                                }
                                                style={{
                                                  pointerEvents: "none",
                                                  overflow: "hidden",
                                                  msOverflowStyle: "none",
                                                  scrollbarWidth: "none",
                                                }}
                                              />
                                            </fieldset>
                                          </div>
                                        </div>
                                        <div className="text-sm font-semibold flex items-center justify-center my-1">
                                          {item.name}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}

                              {/* Radiology Section */}
                              {!radiologyEmpty && (
                                <div>
                                  {row?.Radiology.map((item, itemIndex) => {
                                    const blob = new Blob([item.data], {
                                      type: "application/pdf",
                                    });
                                    const urlRadio = URL.createObjectURL(blob);
                                    return (
                                      <div
                                        className="bg-white shadow-md rounded-md border border-gray-300 m-5 p-1"
                                        key={itemIndex}
                                      >
                                        <div
                                          className="flex items-center justify-center"
                                          onClick={(e) => {
                                            setDocumentView(true);
                                            setpdf(item);
                                          }}
                                        >
                                          <div className="cursor-pointer overflow-hidden relative w-[100px] h-[141px]">
                                            {item?.name !== pdf?.name ? (
                                              <iframe
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                }}
                                                title="PDF Preview"
                                                className="absolute inset-0 w-full h-full"
                                                src={`${urlRadio}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                                                style={{
                                                  pointerEvents: "none",
                                                  overflow: "hidden",
                                                  msOverflowStyle: "none",
                                                  scrollbarWidth: "none",
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}
                                            <iframe
                                              title="PDF Preview"
                                              onClick={(e) => {
                                                e.preventDefault();
                                              }}
                                              className="absolute inset-0 w-full h-full"
                                              src={
                                                item?.name === pdf?.name
                                                  ? `${urlRadio}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`
                                                  : ""
                                              }
                                              style={{
                                                pointerEvents: "none",
                                                overflow: "hidden",
                                                msOverflowStyle: "none",
                                                scrollbarWidth: "none",
                                              }}
                                            />
                                          </div>
                                        </div>
                                        <div className="text-sm font-semibold flex items-center justify-center my-1">
                                          {item.name}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                              {!cardiologyEmpty && (
                                <div>
                                  {row?.Cardiology.map((item, itemIndex) => {
                                    const blob = new Blob([item.data], {
                                      type: "application/pdf",
                                    });
                                    const urlCardiology =
                                      URL.createObjectURL(blob);
                                    return (
                                      <div className="m-5 p-1" key={itemIndex}>
                                        <div
                                          className="flex items-center justify-center"
                                          onClick={(e) => {
                                            // e.preventDefault();
                                            setDocumentView(true);
                                            setpdf(item);
                                          }}
                                        >
                                          <div className="cursor-pointer overflow-hidden relative w-[100px] h-[141px]">
                                            {item?.name !== pdf?.name ? (
                                              <iframe
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                }}
                                                title="PDF Preview"
                                                className="absolute inset-0 w-full h-full"
                                                src={`${urlCardiology}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                                                style={{
                                                  pointerEvents: "none",
                                                  overflow: "hidden",
                                                  msOverflowStyle: "none",
                                                  scrollbarWidth: "none",
                                                }}
                                              />
                                            ) : (
                                              ""
                                            )}
                                            <iframe
                                              title="PDF Preview"
                                              onClick={(e) => {
                                                e.preventDefault();
                                              }}
                                              className="absolute inset-0 w-full h-full"
                                              src={
                                                item?.name === pdf?.name
                                                  ? `${urlCardiology}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`
                                                  : ""
                                              }
                                              style={{
                                                pointerEvents: "none",
                                                overflow: "hidden",
                                                msOverflowStyle: "none",
                                                scrollbarWidth: "none",
                                              }}
                                            />
                                          </div>
                                        </div>
                                        <div className="text-sm font-semibold flex items-center justify-center my-1">
                                          {item.name}
                                        </div>
                                      </div>
                                    );
                                  })}
                                </div>
                              )}
                            </div>
                          );
                        })
                      )
                    ) : (
                      <div className="text-center text-gray-500 ">
                        No document uploaded
                      </div>
                    )}
                  </div>
                </div>
                <div className="border border-gray-300 rounded-md">
                  <div className="bg-[#DBE4FF] rounded-t-md font-semibold text-[#1E3A8A] p-2">
                    Other Documents
                  </div>
                  <div>
                    {filterDocumentArr?.length > 0 &&
                      filterDocumentArr.map((row, index) => {
                        return (
                          <div key={index}>
                            <div>
                              {row?.CasePaper && (
                                <div>
                                  <div className=" m-5 p-1 ">
                                    <div>
                                      <div className="flex items-center justify-center ">
                                        <div
                                          onClick={(e) => {
                                            e.preventDefault();
                                            setDocumentView(true);
                                            setpdf(row.CasePaper);
                                          }}
                                          className="cursor-pointer overflow-hidden relative w-[100px] h-[150px]"
                                        >
                                       <img
                                            src={Thumbnail}
                                            width="100px"
                                            height="180px"
                                            className="border border-gray-500"
                                          />
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                  </div>
                  <div>
                    {filterDocumentArr?.length > 0 &&
                      filterDocumentArr.map((row, index) => {
                        return (
                          <div key={index}>
                            {row?.mrd &&
                              row?.mrd.map((mrdItem, MrdIndex) => {
                                const parsedDocPath = mrdItem?.docpath;
                                return (
                                  <div key={MrdIndex}>
                                    {parsedDocPath?.map((docVal, docIndex) => {
                                      const blob = new Blob([docVal.filePdf], {
                                        type: "application/pdf",
                                      });
                                      const urlMrd = URL.createObjectURL(blob);
                                      return (
                                        <div key={docIndex}>
                                          <div className=" m-5 p-1 ">
                                            <div>
                                              <div
                                                className="flex items-center "
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  setDocumentView(true);
                                                  setImage(parsedDocPath);
                                                  setpdf(null);
                                                }}
                                              >
                                                {docVal?.isImage === true ? (
                                                  <>
                                                    <img
                                                      src={docVal?.fileSrc}
                                                      alt="Image"
                                                      width="200"
                                                      height="350"
                                                    />
                                                  </>
                                                ) : (
                                                  <div className="cursor-pointer overflow-hidden relative w-[100px] h-[141px] flex items-center">
                                                    {docVal?.name !==
                                                    pdf?.name ? (
                                                      <iframe
                                                        onClick={(e) => {
                                                          e.preventDefault();
                                                        }}
                                                        title="PDF Preview"
                                                        className="absolute inset-0 w-full h-full"
                                                        src={`${urlMrd}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`}
                                                        style={{
                                                          pointerEvents: "none",
                                                          overflow: "hidden",
                                                          msOverflowStyle:
                                                            "none",
                                                          scrollbarWidth:
                                                            "none",
                                                        }}
                                                      />
                                                    ) : (
                                                      ""
                                                    )}
                                                    <iframe
                                                      title="PDF Preview"
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                      }}
                                                      className="absolute inset-0 w-full h-full"
                                                      src={
                                                        docVal?.name ===
                                                        pdf?.name
                                                          ? `${urlMrd}#toolbar=0&navpanes=0&scrollbar=0&view=FitH`
                                                          : ""
                                                      }
                                                      style={{
                                                        pointerEvents: "none",
                                                        overflow: "hidden",
                                                        msOverflowStyle: "none",
                                                        scrollbarWidth: "none",
                                                      }}
                                                    />
                                                  </div>
                                                )}
                                              </div>

                                              <div className="text-sm font-semibold flex items-center justify-center my-1">
                                                {docVal?.fileName}
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })}
                                  </div>
                                );
                              })}
                            {/* <hr className="p-[4px] text-slate-900" /> */}
                          </div>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
      {openInvestigationModal && (
        <PathologyReportModal
          openInvestigationModal={openInvestigationModal}
          setOpenInvestigationModal={setOpenInvestigationModal}
          pathHistoryData={pathHistoryData}
          selectedRow={selectedRow}
          patientInfo={props.patientDetails}
          LIMSType={LIMSType}
          setRadioHistoryData={setRadioHistoryData}
          radioHistoryData={radioHistoryData}
        />
      )}
      {/* {openDicomModal === true && (
        <CommonDicomModal
          openDicomModal={openDicomModal}
          setOpenDicomModal={setOpenDicomModal}
        />
      )} */}
    </div>
  );
}
export default React.memo(PatientHistoryModalNewAll);

